export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('table_label_fabric_position') || '面料位置',
    field: 'fabricPositionName',
    width: 100,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabric_content') || '面料信息',
    field: 'fabricContent',
    minwidth: 100,
    align: 'left',
    showHeaderOverflow: true,
  },
]
